import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'

import HomeLarge from '../../components/HomeLarge';
import HomeMini from '../../components/HomeMini';
import axiosConfig from '../../config/axiosConfig'

import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'

const current = new Date();

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white',

    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow',
    })
}


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}



const firstDate = new Date();
const currentDate = new Date();

class FleetOverviewGraph extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fodata: {},

            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),

            timeFrameDropDownOptionsNew: [
                { value: 0, label: monthNames[current.getMonth()]},
                { value: 1, label: monthNames[current.getMonth()-1] },
                { value: 2 , label: monthNames[current.getMonth()-2] },
                { value: 3, label: monthNames[current.getMonth()-3] }
            ],


            HSSETabOption: 1,
            HSSETabGroup: 0,
            HSSETabVehicle: 0,
            HSSEBarOption: 1,
            HSSEBarGroup: 0,
            HSSEBarVehicle: 0,
            HSSEPieOption: 1,
            HSSEPieGroup: 0,
            HSSEPieVehicle: 0,
            TimeFrameId: 'three_month',

            srcURL_Shell_Card_Transaction_Value_In_Litre_Pie: '',
            srcURL_Shell_Card_Transaction_Value_In_PKR_Pie: '',
            srcURL_Total_KMs_Travelled_Pie: '',
            srcURL_Total_Driven_Hours_Pie: '',
            srcURL_Average_Shell_Card_Mileage_Pie: '',

            srcURL_Shell_Card_Transaction_Value_In_Litre_bar: '',
            srcURL_Shell_Card_Transaction_Value_In_PKR_bar: '',
            srcURL_Total_KMs_Travelled_bar: '',
            srcURL_Total_Driven_Hours_bar: '',
            srcURL_Average_Shell_Card_Mileage_bar: '',

            srcURL_FleetBulletin: '',

            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',

            Option: '',
            Group: '',
            searchCriteria: 'vrn',
            VRNGroupMultiID: '',



            searchCriteria1: 'vrn',
            Option1: 'vrn',
            Group1: '0',
            Group1Id: '',
            Vehicle1: '',
            Vehicle1Id: '',
            TimeFrameId1: 0,

            searchCriteria2: 'vrn',
            Option2: 'vrn',
            Group2: '0',
            Group2Id: '',
            Vehicle2: '',
            Vehicle2Id: '',
            TimeFrameId2: 'three_month',
            VRNMappingMasterId: '',
            VRNGroupMasterId: '',
        };
        this.HSSETabOptionChange = this.HSSETabOptionChange.bind(this)
        this.HSSETabGroupChange = this.HSSETabGroupChange.bind(this)
        this.HSSETabVehicleChange = this.HSSETabVehicleChange.bind(this)

        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)

        this.optionChange1 = this.optionChange1.bind(this)
        this.groupChange1 = this.groupChange1.bind(this)
        this.vehicleChange1 = this.vehicleChange1.bind(this)

        this.getFOData = this.getFOData.bind(this);
        this.getFOTable1Data = this.getFOTable1Data.bind(this);

        this.changeOptionTime = this.changeOptionTime.bind(this);
        this.changeOptionTime1 = this.changeOptionTime1.bind(this)
        this.changeOptionTime2 = this.changeOptionTime2.bind(this)

        this.optionChange2 = this.optionChange2.bind(this)
        this.groupChange2 = this.groupChange2.bind(this)
        this.vehicleChange2 = this.vehicleChange2.bind(this)



    }

    async changeOptionTime(selectedOption) {

        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async changeOptionTime2(selectedOption) {

        await this.setState({ TimeFrameId2: selectedOption.value })
    }


    async HSSETabOptionChange(selectedOption) {

        if (selectedOption.value == 1) {
            await this.setState({ HSSETabOption: selectedOption, HSSETabGroup: 0, HSSETabVehicle: 0 })
            this.getFOTable1Data();
        }
        else
            this.setState({ HSSETabOption: selectedOption, HSSETabGroup: 0, HSSETabVehicle: 0 })

        console.log('selected dropdown Option is now ', this.state.HSSETabOption)
    }
    async HSSETabVehicleChange(selectedVehicle) {
        console.log(selectedVehicle)
        await this.setState({ HSSETabVehicle: selectedVehicle, HSSETabGroup: 0 })
        this.getFOTable1Data();

    }
    async HSSETabGroupChange(selectedGroup) {
        console.log(selectedGroup)
        await this.setState({ HSSETabGroup: selectedGroup, HSSETabVehicle: 0 })
        this.getFOTable1Data();

    }

    /*Start:For Pie Chart*/
    async changeOptionTime1(selectedOption) {

        await this.setState({ TimeFrameId1: selectedOption.value })

        this.bindAllPieChart();
    }

    async optionChange1(selectedOption) {

        if (selectedOption == 1) {
            await this.setState({ searchCriteria1: "vrn" })
            this.bindAllPieChart();
        }
        else
            await this.setState({ Option1: selectedOption, Group1: 0, Vehicle1: 0 })
    }

    async vehicleChange1(selectedVehicle) {


        await this.setState({ Vehicle1: selectedVehicle, Group1: 0 })

    }

    async groupChange1(selectedGroup) {
        console.log("Selected group are : ", selectedGroup)

        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.bindAllPieChart();

    }

    /*End: For Pie Chart*/

    /* Start of Tabular Data */

    async optionChange(selectedOption) {
        if (selectedOption == 1) {
            await this.setState({ searchCriteria: "vrn" })
            this.getTabularData();
        }
        else
            await this.setState({ Option: selectedOption, Group: 0 })
    }

    async vehicleChange(selectedVehicle) {


        // await this.setState({ Vehicle: selectedVehicle, Group: 0 })

    }

    async groupChange(selectedGroup) {

        await this.setState({ searchCriteria: "vrngroup", VRNGroupMultiID: selectedGroup })
        this.getTabularData();

    }

    /* End of Tabular Data */




    getFOData() {

        axiosConfig.post('Portal/GetFleetOverView', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                this.setState({ fodata: res.data.fleetOverView[0] })
            })
            .catch(console.error)
            .finally(() => {

            });
    }


    componentDidMount() {

        this.getTabularData();

        this.getFOData();
        this.getFOTable1Data();

        this.bindAllPieChart();
        //this.bindAllBarChart();

    }

    async getTabularData() {
        let DateRange = this.state.TimeFrameId;
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "FleetMileageTransMinAvgMaxTrend";
        let URL_PARAMETERS = 'reportName=' + reportName + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMultiID + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_FleetBulletin: ReportFullURL })
    }

    // 
    getFOTable1Data() {

        axiosConfig.post('Portal/GetHighestFleetOverView_Deviation', {
            "TimeFrame": this.state.TimeFrameId,
            "SearchTypeId": this.state.HSSETabOption,
            "CardMappingMasterId": this.state.HSSETabVehicle,
            "VRNGroupMasterId": this.state.HSSETabGroup,
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
        })
            .then((res) => {
                this.setState({ mostDeviationData: res.data.deviation })
            })
            .catch(console.error)
            .finally(() => {

            });
    }

    async changeOptionTime(selectedOption) {
        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async bindAllPieChart() {

        /*In Liter*/
        let MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "PieChart_ShellCardLPKR";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=L&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=L&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Shell_Card_Transaction_Value_In_Litre_Pie: ReportFullURL, showReport: true })

        /*In PKTimeFrameId1R*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardLPKR";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=PKR&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=PKR&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Shell_Card_Transaction_Value_In_PKR_Pie: ReportFullURL, showReport: true })

        /*Total KMs Travelled*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=Km&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=Km&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_KMs_Travelled_Pie: ReportFullURL, showReport: true })

        /*Total Driven Hours*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=Hr&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectChartView=Hr&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_Driven_Hours_Pie: ReportFullURL, showReport: true })

        /*Average Shell Card Mileage (KM/L)*/
        MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "PieChart_ShellCardKmPerLtr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Average_Shell_Card_Mileage_Pie: ReportFullURL, showReport: true })
    }

    /*Start:Bar Chart Area*/
    async bindAllBarChart() {



        /*In Liter*/
        let DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "BarChart_ShellCardLPKR";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectedAggegate=L&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedAggegate=L&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedAggegate=L&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Shell_Card_Transaction_Value_in_Litre_bar: ReportFullURL, showReport: true })

        /*In PKR*/
        DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "BarChart_ShellCardLPKR";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedAggegate=PKR&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedAggegate=PKR&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedAggegate=PKR&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Shell_Card_Transaction_Value_in_PKR_bar: ReportFullURL, showReport: true })

        /*Total Driven*/
        DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "BarChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedAggegate=Hr&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedAggegate=Hr&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedAggegate=Hr&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }


        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_Driven_Hours_bar: ReportFullURL, showReport: true })

        /*In Total KM*/
        DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "BarChart_ShellCardKmHr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedAggegate=Km&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedAggegate=Km&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedAggegate=Km&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Total_KMs_Travelled_bar: ReportFullURL, showReport: true })


        /*Average Shell Card Mileage */
        DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        UserBranchID = localStorage.getItem('selectedBranch')
        reportName = "BarChart_ShellCardKmPerLtr";
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Average_Shell_Card_Mileage_bar: ReportFullURL, showReport: true })
    }

    async optionChange2(selectedOption) {
        if (selectedOption == 1) {

            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
            await this.setState({ searchCriteria2: "vrn" })
            this.bindAllBarChart();
        }
        else
            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
    }

    async vehicleChange2(selectedVehicle) {
        await this.setState({ searchCriteria1: "vrn", VRNMappingMasterId: selectedVehicle })
        this.bindAllBarChart();
    }

    async groupChange2(selectedGroup) {

        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.bindAllBarChart();
    }

    render() {

        return (

            <div>
                <Container>
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>

                    <Col className="col-md-12">

                        <CardDeck>
                            <HomeLarge Title="Fleet Overview" Icon="fa fa-truck font-medium-5" />
                            <HomeMini status={this.state.fodata.volumeDifference} quantityPrice={this.state.fodata.volumeCurrentMonth + ' L'} Icon="fa fa-credit-card font-medium-5" percentage="-1" description="Shell Card Volume (L)" cssName="avatar p-50 m-0 mb-1 avatar-blue" />
                            <HomeMini status={this.state.fodata.amountDifference} quantityPrice={this.state.fodata.amountCurrentMonth + ' PKR'} Icon="fa fa-money text-warning font-medium-5" percentage="-1" description="Shell Card Spend (PKR)" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelDistanceDifference} quantityPrice={this.state.fodata.totalTravelsDistanceCurrentMonth + ' KM'} Icon="fa fa-road text-primary font-medium-5" percentage="-1" description="Distance Travelled" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelTimeDifference} quantityPrice={this.state.fodata.totalTravelsTimeCurrentMonth + ' Hours'} Icon="fa fa-tint text-primary font-medium-5" percentage="-1" description="Total Driven Hours" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.avgMileageDifference} quantityPrice={this.state.fodata.avgMileagePerKMCurrentMonth + ' KM'} Icon="fa fa-database text-success font-medium-5" percentage="-1" description="Average Vehicle Shell Card Mileage (KM/L)" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                        </CardDeck>

                    </Col>

                    </Row>

                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Fleet Bulletin</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptions}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime}
                                                    defaultValue={{ label: "Last 3 months", value: 1 }}
                                                    isDisabled={true}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">

                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.optionChange}
                                                    onGroupChange={this.groupChange}
                                                    onVehicleChange={this.vehicleChange}
                                                />


                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-xl-12 col-lg-12 col-md-12 p-0 pr-2">
                                            <Card>
                                                <Card.Body className="p-0">
                                                    <Iframe src={this.state.srcURL_FleetBulletin} height="430" width="1250" />

                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>


                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Fleet Summary</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptionsNew}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime1}
                                                    defaultValue={{ label: monthNames[current.getMonth()], value: 0 }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">

                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.optionChange1}
                                                    onGroupChange={this.groupChange1}
                                                    onVehicleChange={this.vehicleChange1}
                                                />
                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>

                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">


                                                        <Row>
                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_In_Litre_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_In_PKR_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_KMs_Travelled_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_Driven_Hours_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Average_Shell_Card_Mileage_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>


                    {/* <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Fleet Analysis</h3>
                                </Card.Title>
                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptionsNew}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime2}
                                                    defaultValue={{ label: "Last 3 months", value: "three_month" }}
                                                    isDisabled={true}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    isMultiInVehicle='true'
                                                    showVehiclesInDropDown='yes'
                                                    onOptionChange={this.optionChange2}
                                                    onGroupChange={this.groupChange2}
                                                    onVehicleChange={this.vehicleChange2}
                                                ></GroupVRNSelect>


                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>


                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">


                                                        <Row>
                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_in_Litre_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Shell_Card_Transaction_Value_in_PKR_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_KMs_Travelled_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Total_Driven_Hours_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Average_Shell_Card_Mileage_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                        </Row>


                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>

                        </Col>


                    </Row> */}


                </Container>
            </div>
        );
    }
}

export default FleetOverviewGraph;
